<template>
  <LoadingButton
    @click.native="download"
    :loading="downloading"
    type="button"
    class="text-nowrap btn btn-primary btn-sm"
    small
  >
    Download
  </LoadingButton>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton';
const fileDownload = require("js-file-download");
import helpers from '@/Mixins/helpers';

export default {
  mixins: [helpers],

  components: {
    LoadingButton
  },

  props: {
    asset: Object,
  },

  data() {
    return {
      downloading: false,
    };
  },

  methods: {
    download() {
      this.downloading = true;

      let route = this.route("asset.download", this.asset.id);
      if (this.userHasType('counter')) {
        route = this.route("asset.review.download", this.asset.id);
      }

      console.log(route)

      window
        .axios({
          url: route,
          method: "GET",
          responseType: "blob",
        })
        .then((response) => {
          console.log(response)

          this.downloading = false;

          if (response.data.type === 'application/pdf') {
            const filename = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
            fileDownload(response.data, filename.replace(/['"]+/g, ''));
          } else {
            this.$emit("triggered");
          }
        });
        // .catch((error) => {
        //   this.$emit("triggered");
        //   this.downloading = false;

        //   this.$emit("error", error.response.data.errors);
        //   throw new Error(error);
        // });
    },
  },
};
</script>